import type { SVGProps } from 'react';

const SvgCheckBullet = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M10 19.6A9.6 9.6 0 1 0 10 .4a9.6 9.6 0 0 0 0 19.2m4.448-11.152a1.2 1.2 0 1 0-1.697-1.697L8.8 10.703 7.248 9.15a1.2 1.2 0 0 0-1.697 1.697l2.4 2.4a1.2 1.2 0 0 0 1.697 0z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgCheckBullet;
